module.exports = __webpack_public_path__ + "img/room7.37d7837d.gif";